module.exports = __webpack_public_path__ + "img/filter-focused.0258602c.svg";